import { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { ubemIoApi } from 'src/redux/services/ubem'
import { clearData as clearAnalysisData } from 'src/redux/slices/analysis/reducers'
import { useTabNavigation } from 'src/redux/slices/navigation/hooks'
import { deleteProject } from 'src/redux/slices/project/endpoints'
import { activateProject, deactivateProject } from 'src/redux/slices/project/reducers'
import {
  clearAllData as clearUmibuilderData,
  setCloudContext,
} from 'src/redux/slices/umibuilder/reducers'
import { clearAllData as clearUpgradesData } from 'src/redux/slices/upgrades/reducers'
import { Project } from 'src/types/database-model'

import { Button, Grid, IconButton, Typography } from '@material-ui/core'
import DeleteIcon from '@material-ui/icons/Delete'
import FolderOpenIcon from '@material-ui/icons/FolderOpen'

//// API Hooks etc
const { invalidateTags } = ubemIoApi.util

// TODO: migrate this componnt to a DataTable row
///// Component
type ProjectProps = Pick<Project, 'title' | 'lat' | 'lon' | 'countryISO3' | 'id' | 'buildingCount'>
const ProjectItem: React.FC<ProjectProps> = ({
  title,
  lat,
  lon,
  countryISO3,
  id,
  buildingCount,
}) => {
  const { goToTab } = useTabNavigation('/project')
  const dispatch = useDispatch()

  const activate = useCallback(() => {
    dispatch(activateProject(id))
    dispatch(clearUmibuilderData())
    dispatch(clearAnalysisData())
    dispatch(clearUpgradesData())
    dispatch(invalidateTags(['Active Project', 'Scenarios']))
    goToTab('tasks')
  }, [id, dispatch, goToTab])

  const [trigger] = deleteProject.useMutation()
  const deleteProj = useCallback(() => {
    dispatch(deactivateProject())
    dispatch(setCloudContext(false))
    dispatch(clearUmibuilderData())
    dispatch(clearUpgradesData())
    dispatch(clearAnalysisData())
    trigger({ id, includeFiles: false })
    goToTab('../account/projects')
  }, [id, trigger, goToTab, dispatch])

  return (
    <Grid container item spacing={2} alignItems='center'>
      <Grid item>
        <Button
          variant='outlined'
          color='primary'
          startIcon={<FolderOpenIcon />}
          size='small'
          onClick={activate}
        >
          Open
        </Button>
      </Grid>
      <Grid item xs={2}>
        <Typography variant='overline'>{title}</Typography>
      </Grid>
      {/* <Grid item>
                <Typography>
                    {gis_file_location ?? "No city listed."}
                </Typography>
            </Grid> */}
      <Grid item xs={countryISO3 ? 1 : 2}>
        <Typography variant='body2'>{countryISO3 ?? 'No GIS data yet.'}</Typography>
      </Grid>
      <Grid item xs={2}>
        {lat && lon && (
          <Typography variant='body2'>
            ({lat}, {lon})
          </Typography>
        )}
      </Grid>
      <Grid item>
        {buildingCount && <Typography variant='body2'>{buildingCount} buildings</Typography>}
      </Grid>
      <Grid item>
        <IconButton size='small' onClick={deleteProj}>
          <DeleteIcon />
        </IconButton>
      </Grid>
    </Grid>
  )
}
export default ProjectItem
